exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-case-studies-dato-cms-case-study-slug-tsx": () => import("./../../../src/pages/case-studies/{DatoCmsCaseStudy.slug}.tsx" /* webpackChunkName: "component---src-pages-case-studies-dato-cms-case-study-slug-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

